import { Icon } from '@antimatterhq/ui/components/icon';
import { Button } from '@antimatterhq/ui/components/button';
import { cn } from '@/lib/utils';
type AssignToButtonProps = {
  disabled?: boolean;
  onClick: () => void;
};
export const AssignToButton = ({ disabled, onClick }: AssignToButtonProps) => {
  return (
    <Button
      variant={'default'}
      size="small"
      className={cn('h-8 w-max justify-start text-left')}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon icon="lucide:square-user" />
      <span>Assign to</span>
    </Button>
  );
};
